import {
  ColumnHeaderMultiSelectFilter,
  UpdateFilterType,
} from "../../ReusableHeaderFilter/ColumnHeaderMultiSelectFilter";
import { FilterKeys } from "../Task1120FilterOptions";
import { Task1120TrackerFilterType } from "../Task1120TrackerFilter";

export const ADD_DETAILS = "ADD_DETAILS";
export const INKLE_PRICING = "INKLE_PRICING";
export const IN_PROGRESS = "IN_PROGRESS";
export const COMPLETED = "COMPLETED";
export const AMENDMENT = "AMENDMENT";
export const AMENDMENT_FILED = "AMENDMENT_FILED";

export const TaskStatusColumnHeader = ({
  values,
  updateFilter,
  name,
  header,
  extraFilters = [],
}: Omit<Task1120TrackerFilterType, "updateFilter"> & {
  updateFilter: UpdateFilterType;
  name: FilterKeys;
  header: string;
  extraFilters?: { label: string; value: string }[];
}) => {
  const taskStates = [
    ...extraFilters,
    { label: "Add Details", value: ADD_DETAILS },
    { label: "Inkle Pricing", value: INKLE_PRICING },
    { label: "In Progress", value: IN_PROGRESS },
    { label: "Completed", value: COMPLETED },
    { label: "Amendment", value: AMENDMENT },
    { label: "Amendment Filed", value: AMENDMENT_FILED },
  ];

  return (
    <div className="t-flex t-items-center t-justify-between t-w-full">
      <div>{header}</div>
      <ColumnHeaderMultiSelectFilter
        filterName={name}
        options={taskStates}
        selected={typeof values[name] === "string" ? values[name] : null}
        updateFilter={updateFilter}
        className="t-w-72"
      />
    </div>
  );
};
